<div>
    <p class="about-title">ABOUT</p>
    <p class="about-subtitle">GUI</p>
    <div class="about-component">
        <p class="about-component-name">GUI-ORCAN: </p>
        <p [class.about-available]="guiVersion != undefined"
           [class.about-unavailable]="guiVersion == undefined">{{guiVersion || 'UNAVAILABLE'}}</p>
    </div>
    <p class="about-subtitle">MICROSERVICES</p>
    <div class="about-component">
        <p class="about-component-name">MS-SPECIALORDERS: </p>
        <p [class.about-available]="specialOrdersVersion != undefined"
           [class.about-unavailable]="specialOrdersVersion == undefined">{{specialOrdersVersion || 'UNAVAILABLE'}}</p>
    </div>
    <div class="about-component">
        <p class="about-component-name">MS-CLAIMS: </p>
        <p [class.about-available]="claimsVersion != undefined"
           [class.about-unavailable]="claimsVersion == undefined">{{claimsVersion || 'UNAVAILABLE'}}</p>
    </div>
    <div class="about-component">
        <p class="about-component-name">MS-FILEMANAGER: </p>
        <p [class.about-available]="fileManagerVersion != undefined"
           [class.about-unavailable]="fileManagerVersion == undefined">{{fileManagerVersion || 'UNAVAILABLE'}}</p>
    </div>
    <div class="about-component">
        <p class="about-component-name">MS-SECURITY: </p>
        <p [class.about-available]="securityVersion != undefined"
           [class.about-unavailable]="securityVersion == undefined">{{securityVersion || 'UNAVAILABLE'}}</p>
    </div>
    <div class="about-component">
        <p class="about-component-name">MS-SETTINGS: </p>
        <p [class.about-available]="settingsVersion != undefined"
           [class.about-unavailable]="settingsVersion == undefined">{{settingsVersion || 'UNAVAILABLE'}}</p>
    </div>
    <div class="about-component">
        <p class="about-component-name">MS-EVENTS: </p>
        <p [class.about-available]="eventsVersion != undefined"
           [class.about-unavailable]="eventsVersion == undefined">{{eventsVersion || 'UNAVAILABLE'}}</p>
    </div>
    <div class="about-component">
        <p class="about-component-name">MS-PARTNUMBERCHANGES: </p>
        <p [class.about-available]="partNumberChangesVersion != undefined"
           [class.about-unavailable]="partNumberChangesVersion == undefined">{{partNumberChangesVersion || 'UNAVAILABLE'}}</p>
    </div>
    <div class="about-component">
        <p class="about-component-name">MS-SETTLEMENTS: </p>
        <p [class.about-available]="settlementsVersion != undefined"
           [class.about-unavailable]="settlementsVersion == undefined">{{settlementsVersion || 'UNAVAILABLE'}}</p>
    </div>
    <div class="about-component">
        <p class="about-component-name">MS-BUNDLES: </p>
        <p [class.about-available]="bundlesVersion != undefined"
           [class.about-unavailable]="bundlesVersion == undefined">{{bundlesVersion || 'UNAVAILABLE'}}</p>
    </div>
    <div class="about-component">
        <p class="about-component-name">MS-OAUTH-PROXY: </p>
        <p [class.about-available]="oauthProxyVersion != undefined"
           [class.about-unavailable]="oauthProxyVersion == undefined">{{oauthProxyVersion || 'UNAVAILABLE'}}</p>
    </div>
    <p class="about-subtitle">AGENTS</p>
    <div class="about-component">
        <p class="about-component-name">AG-MATERIAL-VERSION-SCHEDULER: </p>
        <p [class.about-available]="materialSchedulerVersion != undefined"
           [class.about-unavailable]="materialSchedulerVersion == undefined">{{materialSchedulerVersion || 'UNAVAILABLE'}}</p>
    </div>
    <div class="about-component">
        <p class="about-component-name">AG-MATERIAL-ADAPTER: </p>
        <p [class.about-available]="materialAdapterVersion != undefined"
           [class.about-unavailable]="materialAdapterVersion == undefined">{{materialAdapterVersion || 'UNAVAILABLE'}}</p>
    </div>
    <div class="about-component">
        <p class="about-component-name">AG-SPECIALORDER-ADAPTER: </p>
        <p [class.about-available]="specialOrderAdapterVersion != undefined"
           [class.about-unavailable]="specialOrderAdapterVersion == undefined">{{specialOrderAdapterVersion || 'UNAVAILABLE'}}</p>
    </div>
    <div class="about-component">
        <p class="about-component-name">AG-CLAIM-ADAPTER: </p>
        <p [class.about-available]="claimAdapterVersion != undefined"
           [class.about-unavailable]="claimAdapterVersion == undefined">{{claimAdapterVersion || 'UNAVAILABLE'}}</p>
    </div>
</div>